import { jsx as _jsx } from "react/jsx-runtime";
import { RemixBrowser } from '@remix-run/react';
import { startTransition, StrictMode } from 'react';
import { hydrateRoot as reactHydrateRoot } from 'react-dom/client';
export function hydrateRoot() {
    const hydrate = () => {
        startTransition(() => {
            reactHydrateRoot(document, _jsx(StrictMode, { children: _jsx(RemixBrowser, {}) }));
        });
    };
    if (window.requestIdleCallback) {
        window.requestIdleCallback(hydrate);
    }
    else {
        // Safari doesn't support requestIdleCallback
        // https://caniuse.com/requestidlecallback
        window.setTimeout(hydrate, 1);
    }
}
